import React, {
  memo, useCallback, useEffect, useMemo, useRef,
} from 'react'

import { Icon, User } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const prefixIcon = <Icon notSpaced svgComponent={User} color="dark" size="small" />
// Same as the File format dropdown: the panel animates open, and focusing before it is in place
// scrolls the page to an input that is not yet visible.
const SEARCH_FOCUS_DELAY = 300

function Designers() {
  const translate = useTranslate()
  const searchRef = useRef(null)
  const focusTimerRef = useRef(null)

  const designers = useSearchPageStore(state => state.designers ?? EMPTY_ARRAY)
  const scopes = useSearchPageStore(state => state.designerScopes ?? EMPTY_ARRAY)

  // Reset lives inside DesignerContent, which is the only place that can resolve a scope flag back
  // into a designer count. The trigger only needs to know whether anything is on at all.
  const hasSelectedAnyFilter = designers.length > 0 || scopes.length > 0

  useEffect(() => () => {
    clearTimeout(focusTimerRef.current)
  }, [])

  const handleOpenChange = useCallback((isOpen) => {
    // A close inside the delay must cancel the pending focus, or the hidden input would take focus
    // (and scroll the page to itself) after the panel is gone. Same pattern as Features.jsx.
    clearTimeout(focusTimerRef.current)
    if (!isOpen || !searchRef.current) {
      return
    }
    focusTimerRef.current = setTimeout(() => {
      searchRef.current?.focus()
    }, SEARCH_FOCUS_DELAY)
  }, [])

  const content = useMemo(() => <DesignerContent searchRef={searchRef} />, [])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.designers.title')}
      prefixIcon={prefixIcon}
      content={content}
      onOpenChange={handleOpenChange}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
      contentClassName="designer-filter__popover-content"
    />
  )
}

export default memo(Designers)
